var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.544,
    height: 17.544,
    viewBox: "0 0 17.544 17.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M15.351,0H2.193A2.193,2.193,0,0,0,0,2.193V15.351a2.193,2.193,0,0,0,2.193,2.193H15.351a2.193,2.193,0,0,0,2.193-2.193V2.193A2.193,2.193,0,0,0,15.351,0ZM1.1,4.229a1.028,1.028,0,0,1,1.1-.94H15.351a1.028,1.028,0,0,1,1.1.94V15.507a1.028,1.028,0,0,1-1.1.94H2.193a1.028,1.028,0,0,1-1.1-.94Z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M10.011,13.443a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,10.011,13.443Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,13.3,13.443Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,16.59,13.443ZM6.721,16.732a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,6.721,16.732Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,10.011,16.732Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,13.3,16.732Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,16.59,16.732ZM6.721,20.022a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,6.721,20.022Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,10.011,20.022Zm3.289,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,13.3,20.022Z",
    transform: "translate(-2.884 -5.768)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3);
export default __webpack_public_path__ + "static/media/calendar3.6d0baf2637d9eda1a2380ed97f726ea3.svg";
export { ForwardRef as ReactComponent };